import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { MediaAnalysisEmployerBrandingPage } from "@/components/site/MediaAnalysisEmployerBrandingPage";
import { MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION } from "@/content/meta/MediaAnalysisEmployerBrandingPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/media-analysis/employer-branding")({
  head: () => ({
    meta: [
      { title: "Employer Brand Analysis & Monitoring | Perceptica" },
      { name: "description", content: MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION },
      { property: "og:title", content: "Employer Brand Analysis & Monitoring | Perceptica" },
      { property: "og:description", content: MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Employer Brand Analysis & Monitoring | Perceptica" },
      { name: "twitter:description", content: MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/media-analysis/employer-branding" },
      ...ogImageMeta("en", "/media-analysis/employer-branding"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-analysis/employer-branding", service: { name: "Employer branding analysis", description: "Perceptica employer branding analysis for Southeast Europe.", serviceType: "Employer branding analysis" } }),
  }),
  component: MediaAnalysisEmployerBrandingPage,
});
